import type React from "react";
import type { NodeInputProps } from "./helpers";

export const NodeInputHidden: React.FC<NodeInputProps> = ({ attributes }) => {
	// Render a hidden input field
	return (
		<input
			type={attributes.type}
			name={attributes.name}
			value={attributes.value || "true"}
		/>
	);
};
